import React from 'react';

const AboutUs = () => {
    return (
        <div>
            <h1>About us page</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde eum blanditiis dignissimos necessitatibus delectus, quia cumque reprehenderit, non nihil illo dicta in laboriosam a neque nesciunt pariatur id officiis facilis.</p>
        </div>
    );
};

export default AboutUs;